import { Component, inject } from '@angular/core';
import { Validators, NonNullableFormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NomidioPhoneValidators } from '@shared/phone';
import { I18nService } from '@shared/i18n';
import { NomidioErrorsService } from '@shared/services/nomidio-component-errors/nomidio-errors.service';

@Component({
  selector: 'app-user-phone-dialog',
  templateUrl: './user-phone-dialog.component.html',
  styleUrls: ['./user-phone-dialog.component.scss'],
  standalone: false,
})
export class UserPhoneDialogComponent {
  protected readonly i18n = inject(I18nService);
  protected readonly errors = inject(NomidioErrorsService);
  private readonly dialogRef = inject<MatDialogRef<UserPhoneDialogComponent>>(MatDialogRef);
  private readonly fb = inject(NonNullableFormBuilder);

  public form = this.fb.group({
    phone: this.fb.control('', [Validators.required, NomidioPhoneValidators.phone]),
  });
  public get phoneInput() {
    return this.form.controls.phone ?? null;
  }

  public onSubmit() {
    this.dialogRef.close(this.phoneInput.value.trim());
  }

  public onCancel() {
    this.dialogRef.close(null);
  }
}
